// extracted by mini-css-extract-plugin
export var closeButton = "_1n-3";
export var header = "_1n-0";
export var link = "_1n-1";
export var retryButton = "_1n-2";